import { publish } from '$lib/utils/pubsub';
import { siteNotification } from '$lib/utils/notifications/events';

// notification
export function notification(message) {
    publish(new siteNotification(message));
}
